import React from "react";
import "./header.css";
import CTA from "./CTA";
// import A1 from "../../assets/770.png";
import A1 from "../../assets/a1.png";
// import MATY1 from "../../assets/maty2.jpg";

// import A1 from "../../assets/me.png";
import HeaderSocials from "./HeaderSocials";

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5> שלום אני</h5>
        <h1>מתי גורפינקל </h1>
        <h5 className="text-light">Fullstack Developer</h5>
        <CTA />
        <HeaderSocials />
        <div className="me">
          <img className="maty" src={A1} alt="me" />
          {/* <img className="maty" src={MATY1} alt="me" /> */}
        </div>
        <a href="#contact" className="scroll__down">
          גלול למטה
        </a>
      </div>
    </header>
  );
};

export default Header;
